import Vue from 'vue';
import Router from 'vue-router';

import Login from '@/components/Login';
import Home from '@/components/Home';

import Customer from '@/components/claim/Customer';
import CustomerDetail from '@/components/claim/CustomerDetail';
import Refund from '@/components/claim/Refund';
import RefundDetail from '@/components/claim/RefundDetail';
import Nonpayment from '@/components/claim/Nonpayment';
import NonpaymentDetail from '@/components/claim/NonpaymentDetail';
import IncompletedPay from '@/components/incompletedPay/IncompletedPay';
import PayHistory from '@/components/payHistory/PayHistory';
import PurchaseHistory from '@/components/payHistory/PurchaseHistory';
import Sale from '@/components/sale/Sale';
import Device from '@/components/device/Device';
import Product from '@/components/product/Product';
import Order from '@/components/order/Order';
import Stock from '@/components/stock/Stock';
import DeviceSale from '@/components/sale/DeviceSale';

// add by parkchanghyun
import Account from '@/components/account/Account';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: { authRequired: false },
    },
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: { authRequired: true },
    },
    {
      path: '/account',
      name: 'Account',
      component: Account,
      meta: { authRequired: true },
    },
    {
      path: '/customer',
      name: 'Customer',
      component: Customer,
      meta: { authRequired: true },
    },
    {
      path: '/customer/detail',
      name: 'CustomerDetail',
      component: CustomerDetail,
      meta: { authRequired: true },
    },
    {
      path: '/refund',
      name: 'Refund',
      component: Refund,
      meta: { authRequired: true },
    },
    {
      path: '/refund/detail',
      name: 'RefundDetail',
      component: RefundDetail,
      meta: { authRequired: true },
    },
    {
      path: '/nonpayment',
      name: 'Nonpayment',
      component: Nonpayment,
      meta: { authRequired: true },
    },
    {
      path: '/nonpayment/detail',
      name: 'NonpaymentDetail',
      component: NonpaymentDetail,
      meta: { authRequired: true },
    },
    {
      path: '/incompletedPay',
      name: 'IncompletedPay',
      component: IncompletedPay,
      meta: { authRequired: true },
    },
    {
      path: '/payhistory',
      name: 'PayHistory',
      component: PayHistory,
      meta: { authRequired: true },
    },
    {
      path: '/purchasehistory',
      name: 'PurchaseHistory',
      component: PurchaseHistory,
      meta: { authRequired: true },
    },
    {
      path: '/sale',
      name: 'Sale',
      component: Sale,
      meta: { authRequired: true },
    },
    {
      path: '/device',
      name: 'Device',
      component: Device,
      meta: { authRequired: true },
    },
    {
      path: '/product',
      name: 'Product',
      component: Product,
      meta: { authRequired: true },
    },
    {
      path: '/order',
      name: 'Order',
      component: Order,
      meta: { authRequired: true },
    },
    {
      path: '/stock',
      name: 'Stock',
      component: Stock,
      meta: { authRequired: true },
    },
    {
      path: '/deviceSale',
      name: 'DeviceSale',
      component: DeviceSale,
      meta: { authRequired: true },
    },
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

router.beforeEach(async (to, from, next) => {
  if (to.matched.some(routerInfo => routerInfo.meta.authRequired)) {
    if (!Vue.prototype.$isAccessTokenValid() && !await Vue.prototype.$refreshToken()) {
      Vue.prototype.$deleteCookie();
      next({ name: 'Login' });
      return;
    }
  } else if (to.name === 'Login') {
    if (Vue.prototype.$isAccessTokenValid() || await Vue.prototype.$refreshToken()) {
      next({ name: 'Dashboard' });
      return;
    }
  }

  const token = Vue.prototype.$cookie.get('accessToken');
  if (token) {
    const payload = Vue.prototype.$jwtDecode(token);
    if (payload) {
      // monitor 는 불완전결제처리만 가능
      if (payload.role === 4 && (to.name !== 'Home' && to.name !== 'IncompletedPay')) {
        next({ name: 'Home' });
        return;
      }
    }
  }

  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js